<template><section><template>
<h3>滑块</h3>
<div class="bs-docs-section">
<div class="bs-example">
<n3-slider v-model="value" @change="change" orientation="vertical"></n3-slider>
<p>滑块的值: {{value}}</p> 
<p><n3-slider v-model="value1" @change="change" :range="true"></n3-slider></p>
<p>滑块的值: {{value1}}</p> 
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-slider</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">orientation</span>=<span class="hljs-string">"vertical"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-slider</span>&gt;</span>
<span class="hljs-tag">&lt;<span class="hljs-name">n3-slider</span> <span class="hljs-attr">v-model</span>=<span class="hljs-string">"value1"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">:range</span>=<span class="hljs-string">"true"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-slider</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">value</span>: <span class="hljs-number">2</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    change (val) {
      <span class="hljs-built_in">console</span>.log(val)
    }
  }
}
</code></pre>
<h3>参数</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>min</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>最小值</td>
</tr>
<tr>
<td>max</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">0</code></td>
<td>最大值</td>
</tr>
<tr>
<td>step</td>
<td><code v-pre="">Number</code></td>
<td><code v-pre="">1</code></td>
<td>单步增量</td>
</tr>
<tr>
<td>orientation</td>
<td>String<code v-pre="">|</code>horizontal<code v-pre="">|</code>horizontal<code v-pre="">(水平)</code>vertical`(垂直)</td>
<td></td>
<td></td>
</tr>
<tr>
<td>range</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否范围选择</td>
</tr>
<tr>
<td>tooltip</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">show</code></td>
<td>tooltip显示参数 'show' 'hide' 'always'</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>是否禁用</td>
</tr>
<tr>
<td>formatter</td>
<td><code v-pre="">Function</code></td>
<td>-</td>
<td>格式化tooltip显示内容</td>
</tr>
<tr>
<td>width</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>水平显示的宽度</td>
</tr>
<tr>
<td>height</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">220px</code></td>
<td>水平显示的宽度</td>
</tr>
</tbody>
</table>
<h3>事件</h3>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>值变化</td>
<td>(currentValue)</td>
</tr>
</tbody>
</table>
<p>其他表单相关参数，请移步 <a href="#n3FormDocs">表单验证</a> 待验证组件参数</p>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      value:1,
      value1: [1, 2]
    }
  },
  methods: {
    change (val) {
      console.log(val)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3SliderDocs.md?c4bc83e4